import React, { useContext, useEffect, useState } from "react";
import Services from "../../network/Services";
import { UserContext } from "../../App";
import { formatNumberToUS } from "../../control/Constant";
import konsole from "../../network/konsole";


const OrderRecords = ({selectDate,customDate}) => {
    const tableHeader = ['Name','Order Id','Order Amount','Product Name']
    const [orderData,setOrderdata] = useState([])
    const [searchItem,setSearchItem] = useState('')
    const [pageNumber,setPagenumber] = useState(1)
    const {setLoader} = useContext(UserContext);
    const [stopApi,setStopapi] = useState(false)

    useEffect(()=>{
        setStopapi(false)
    },[searchItem,selectDate,customDate.startDate,customDate.endDate])

    useEffect(()=>{
        if((pageNumber == 1 && searchItem != '') || stopApi) return;
        getOrderDetailfunc(pageNumber,searchItem)
    },[pageNumber])

    useEffect(()=>{
        if(stopApi == true) return;
        setOrderdata([])
        getOrderDetailfunc(1,searchItem)
    },[selectDate,customDate.startDate,customDate.endDate,stopApi])

    const getOrderDetailfunc = (pageNumber,searchItem) => {
        let startDate = selectDate == 'custom' ? new Date(customDate.startDate) : selectDate > 0 ? new Date() : '';
        let endDate = startDate == 'custom' ? new Date(customDate.endDate) :  selectDate > 0 ? new Date() : '';
        
        if(selectDate != 'custom' && selectDate > 0){
            startDate?.setDate(startDate?.getDate() - selectDate)
        }

        let jsonObj = {  
            "subtenantId": 2,  
            "startDate": startDate,  
            "endDate": endDate,  
            "pageNumber": pageNumber,  
            "rowsOfPage": 20,  
            "clientUserId": null,
            "searchField" : searchItem || ''
        }
        const getOrderDetailbySubtenantId = Services.getOrderDetailbySubtenantId(jsonObj)
        setLoader(true)
        getOrderDetailbySubtenantId.then((res)=>{
            setLoader(false)
            konsole.log(res,'getOrderDetailbySubtenantId')
            if(pageNumber > 1){
            setOrderdata(prev=> [...prev,...(res.data.data)])
            }else{
            setOrderdata(res.data.data)
            setPagenumber(1)
            }
        }).catch((err)=>{
            setLoader(false)
            konsole.log(err.response.data.status,"getOrderDetailbySubtenantId")
            if(err.response.data.status == 404){
                setStopapi(true)
                setPagenumber(1)
            }
            if(pageNumber == 1){
            setOrderdata([])
            }
        })
    }

    const searchFunc = () => {
        if(searchItem != undefined || searchItem != '' || searchItem != null){
            setStopapi(false)
            getOrderDetailfunc(1,searchItem)
            setPagenumber(1)
        }
    }
    
    const handleKeyDown = (e) => {
        if(e.key == 'Enter'){
            searchFunc()
        }
    }

    const scrollCallback = (e) => {
        
    const node = e.target;
    if (node) {
      const { scrollTop, scrollHeight, clientHeight } = node;
      const scrollScreen = scrollTop + clientHeight;
  
      if (Math.ceil(scrollScreen) >= scrollHeight) {
        setPagenumber(prev => prev+1)
      }
    }
    }
    
    // console.log(orderData,"orderData")

    return <div>
        <div className="my-2 w-50 d-flex gap-2" style={{border:'1px solid lightgrey', borderRadius:'5px'}}>
            <input className="form-control border-0" placeholder="Search by Name, Email and Mat number" onChange={(e)=>{setSearchItem(e.target.value)}} onKeyDown={handleKeyDown} />
            <button style={{background:'none', border:'none'}} onClick={()=>{searchFunc()}}><img className="m-1" width="15px" height="auto" src="/search icon.png"  /></button>
        </div>
        <div className="table-wrapper w-100 h-100" style={{ width: "100%", borderSpacing: 0, maxHeight: "calc(100vh - 45vh)",overflow:'auto'}} onScroll={scrollCallback}>
        {orderData?.length == 0 ? 'No Data' : <table className="table border" style={{ width: "100%", borderCollapse: "separate", borderSpacing: 0}}>
            <thead style={{ position: "sticky", top: 0, backgroundColor: "#fff", zIndex: 1}}>
                <tr className="text-start">
                    {tableHeader.map((e)=>(<th className="text-start align-bottom p-2 fw-bold shadow-sm">{e}</th>))}
                </tr>
            </thead>
            <tbody>
                {orderData.map((item)=>{
                    return item?.orderDetailsVMs?.map((order,orderIndex)=><tr className="border border-1">
                        {orderIndex == 0 && <td rowSpan={item?.orderDetailsVMs?.length} className="text-start w-25 p-1" style={{borderRight: "1px solid #dee2e6"}}><div><h6 className="my-1 fw-bold">{item.clientName}</h6><p className="mb-1">Mat No: {item.matterNo}</p><p className="" style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Email:{""+item.clientEmail}</p></div></td>}
                        <td className="text-start p-1" style={{borderRight: "1px solid #dee2e6"}}>{order.orderId}</td>
                        <td className="text-start p-1" style={{borderRight: "1px solid #dee2e6"}}>{formatNumberToUS(order.totalCost)}</td>
                        <td className="text-start p-0" style={{borderRight: "1px solid #dee2e6"}}>{order.orderProductVMs.map((prod,prodIndex)=> <div className={prodIndex != 0 ? 'border-top p-1' : 'p-1'}>{prod.productName}</div>)}</td>
                        </tr>
                )})}
        </tbody>
        </table>}
        </div>
        </div>
}

export default OrderRecords;